import BannerWelcome from './BannerWelcome'
export default BannerWelcome
